import { TGetNewRefreshTokenProps } from '../../types/token';
import {
  getRefreshTokenFromCookies,
  removeTokensFromCookies,
  setTokensInCookies
} from '../../lib/utils/setTokensInCookies';
import { tokenRefreshAPI } from './authAPI';
import { useAuth } from '../../contexts/AuthContext';

// 새로운 refreshToken을 가져오는 함수
export const getNewRefreshToken = async () => {
  const refreshToken = getRefreshTokenFromCookies();
  if (refreshToken) {
    try {
      const data = { refreshToken };
      const refreshResponse = await tokenRefreshAPI(data); // 리프레시 토큰을 사용해 새로운 엑세스 토큰 발급
      // console.log('새로고침해서 응답반음 refreshResponse', refreshResponse);
      const newAccessToken = refreshResponse.data.accessToken;
      setTokensInCookies({ accessToken: newAccessToken, refreshToken });
      // await checkLoginStatus(); // 갱신 후 다시 체크
      //
      // const userResponse: TMeResponse = await getMeAPI();
      // const userData: TResponseMeData = userResponse.data;
      // setUser(userData);
      // setIsLoggedIn(true);

      return refreshResponse.data as TGetNewRefreshTokenProps;
    } catch (refreshError) {
      // console.error('리프레시 토큰 오류: ', refreshError);
      // 리프레시 토큰도 유효하지 않다면 로그아웃 처리
      if (localStorage.getItem('responseErrorMessage') !== 'true') {
        localStorage.setItem('responseErrorMessage', 'true');
        alert('로그인 정보가 만료되었습니다. 로그아웃 처리 됩니다.');
      }
      removeTokensFromCookies();
      location.href = '/login';
    }
  } else {
    // console.error('refreshToken is null');
    // refreshToken도 없다면 로그아웃 처리
    // if (localStorage.getItem('responseErrorMessage') !== 'true') {
    //   localStorage.setItem('responseErrorMessage', 'true');
    //   alert('로그인 정보가 만료되었습니다. 로그아웃 처리 됩니다.');
    // }
    // removeTokensFromCookies();
    // location.href = '/login';
  }
  return { accessToken: '', refreshToken: ''};
};
